module.exports = __webpack_public_path__ + "static/media/Graphicdesign.0449127e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/oldMunafaMart/Graphicdesign.jpg
// module id = 409
// module chunks = 0